export class ProductAddon {
    public id: number;
	public uuid: string;
	public modifier_id: string;
	public min: number;
	public max: number;
	public modifier_option_id: any;
	
	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);
		}
	}
}
